import { useInitialInfoStore } from '@src/emp-3.0/store/useInitialInfo';

export const workbenchModeTrueButNotWorkbenchAsset = (isBeta) => {
  // Check if the workbench mode is enabled but the asset is not a workbench asset
  return useInitialInfoStore.getState().workbenchMode && !isBeta;
};

export const workbenchModeTrueAndWorkbenchAsset = (isBeta) => {
  // Check if the workbench mode is enabled and the asset is a beta version
  const { workbenchMode } = useInitialInfoStore.getState();
  return workbenchMode && isBeta;
};
